unit View.Cst_Ipi.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls;

type
  TFViewCst_IpiEdit = class(TForm)
    pnlMessage: TPanel;
    lbMessage: TLabel;
    btCloseMessage: TButton;
    DataSource: TDatasource;
    btCancel: TButton;
    btSave: TButton;
    btDelete: TButton;
    lbcst_ipi_id: TLabel;
    edcst_ipi_id: TDBEdit;
    lbnome: TLabel;
    ednome: TDBEdit;
    lbexcluido: TLabel;
    edexcluido: TDBEdit;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    lbexclusao: TLabel;
    edexclusao: TDBEdit;
    XDataClientCst_IpiGet: TXDataWebClient;
    XDataClientCst_IpiDelete: TXDataWebClient;
    Cst_IpiDataset: TXDataWebDataSet;
    Cst_IpiDatasetcst_ipi_id: TStringField;
    Cst_IpiDatasetnome: TStringField;
    Cst_IpiDatasetexcluido: TBooleanField;
    Cst_IpiDatasetinclusao: TDateTimeField;
    Cst_IpiDatasetalteracao: TDateTimeField;
    Cst_IpiDatasetexclusao: TDateTimeField;
    procedure btCloseMessageClick(Sender: TObject);
    procedure btCancelClick(Sender: TObject);
    procedure btSaveClick(Sender: TObject);
    procedure btDeleteClick(Sender: TObject);
    procedure XDataClientCst_IpiGetLoad(Response: TXDataClientResponse);
    procedure XDataClientCst_IpiDeleteLoad(Response: TXDataClientResponse);
    procedure XDataClientCst_IpiDeleteError(Error: TXDataClientError);
    procedure Cst_IpiDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure WebFormCreate(Sender: TObject);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    procedure InsertEntity;
    procedure LoadEntity;
    procedure ShowNotification(Notification: string);
    procedure HiddenNotification;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewCst_IpiEdit: TFViewCst_IpiEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewCst_IpiEdit }

procedure TFViewCst_IpiEdit.btSaveClick(Sender: TObject);
begin
  if Cst_IpiDataset.State in dsEditModes then
  begin
        Cst_IpiDataset.Post;
    Cst_IpiDataset.ApplyUpdates;
  end
  else
    FShowListProc;
end;

procedure TFViewCst_IpiEdit.btDeleteClick(Sender: TObject);
begin
  if Cst_IpiDataset.State in dsEditModes then
    Cst_IpiDataset.Post;
  XDataClientCst_IpiDelete.Delete(Cst_IpiDataset.EntitySetName,
    TJSObject(Cst_IpiDataset.CurrentData));
end;


class function TFViewCst_IpiEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewCst_IpiEdit.HiddenNotification;
begin
  pnlMessage.ElementHandle.hidden := True;
end;

procedure TFViewCst_IpiEdit.InsertEntity;
begin
  Cst_IpiDataset.Close;
  Cst_IpiDataset.SetJsonData('{}');
  Cst_IpiDataset.Open;
  Cst_IpiDataset.Insert;
end;

class function TFViewCst_IpiEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewCst_IpiEdit(AForm).FInserting := AInserting;
    TFViewCst_IpiEdit(AForm).FId := AId;
    TFViewCst_IpiEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewCst_IpiEdit(AForm).InsertEntity
    else
      TFViewCst_IpiEdit(AForm).LoadEntity;
    TFViewCst_IpiEdit(AForm).btDelete.Enabled := not AInserting;
  end;

begin
  Application.CreateForm(TFViewCst_IpiEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewCst_IpiEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    Cst_IpiDataset.Connection.Model.DefaultSchema.FindEntityType(
      Cst_IpiDataset.EntitySetName
    )
  );
  XDataClientCst_IpiGet.Get(Cst_IpiDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewCst_IpiEdit.ShowNotification(Notification: string);
begin
  lbMessage.Caption := Notification;
  pnlMessage.ElementHandle.hidden := False;
end;

procedure TFViewCst_IpiEdit.btCloseMessageClick(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewCst_IpiEdit.WebFormCreate(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewCst_IpiEdit.XDataClientCst_IpiGetLoad(Response: TXDataClientResponse);
begin
  Cst_IpiDataset.Close;
  Cst_IpiDataset.SetJsonData(Response.Result);
  Cst_IpiDataset.Open;
  
  Cst_IpiDataset.Edit;  
end;

procedure TFViewCst_IpiEdit.XDataClientCst_IpiDeleteError(
  Error: TXDataClientError);
begin
  ShowNotification(Error.ErrorMessage);
end;

procedure TFViewCst_IpiEdit.XDataClientCst_IpiDeleteLoad(
  Response: TXDataClientResponse);
begin
  FShowListProc;
end;

procedure TFViewCst_IpiEdit.Cst_IpiDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      ShowNotification(ResolveInfo.Error);
      Exit;
    end;
  end;
  FShowListProc;
end;

procedure TFViewCst_IpiEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewCst_IpiEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlMessage := TPanel.Create('view.cst_ipi.form.message');
  lbMessage := TLabel.Create('view.cst_ipi.form.message.label');
  btCloseMessage := TButton.Create('view.cst_ipi.form.message.button');
  btCancel := TButton.Create('view.cst_ipi.form.btBack');
  btSave := TButton.Create('view.cst_ipi.form.btSave');
  btDelete := TButton.Create('view.cst_ipi.form.btDelete');
  lbcst_ipi_id := TLabel.Create('view.cst_ipi.form.lbcst_ipi_id');
  edcst_ipi_id := TDBEdit.Create('view.cst_ipi.form.edcst_ipi_id');
  lbnome := TLabel.Create('view.cst_ipi.form.lbnome');
  ednome := TDBEdit.Create('view.cst_ipi.form.ednome');
  lbexcluido := TLabel.Create('view.cst_ipi.form.lbexcluido');
  edexcluido := TDBEdit.Create('view.cst_ipi.form.edexcluido');
  lbinclusao := TLabel.Create('view.cst_ipi.form.lbinclusao');
  edinclusao := TDBEdit.Create('view.cst_ipi.form.edinclusao');
  lbalteracao := TLabel.Create('view.cst_ipi.form.lbalteracao');
  edalteracao := TDBEdit.Create('view.cst_ipi.form.edalteracao');
  lbexclusao := TLabel.Create('view.cst_ipi.form.lbexclusao');
  edexclusao := TDBEdit.Create('view.cst_ipi.form.edexclusao');
  DataSource := TDataSource.Create(Self);
  Cst_IpiDataset := TXDataWebDataSet.Create(Self);
  Cst_IpiDatasetcst_ipi_id := TStringField.Create(Self);
  Cst_IpiDatasetnome := TStringField.Create(Self);
  Cst_IpiDatasetexcluido := TBooleanField.Create(Self);
  Cst_IpiDatasetinclusao := TDateTimeField.Create(Self);
  Cst_IpiDatasetalteracao := TDateTimeField.Create(Self);
  Cst_IpiDatasetexclusao := TDateTimeField.Create(Self);
  XDataClientCst_IpiGet := TXDataWebClient.Create(Self);
  XDataClientCst_IpiDelete := TXDataWebClient.Create(Self);

  pnlMessage.BeforeLoadDFMValues;
  lbMessage.BeforeLoadDFMValues;
  btCloseMessage.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  btSave.BeforeLoadDFMValues;
  btDelete.BeforeLoadDFMValues;
  lbcst_ipi_id.BeforeLoadDFMValues;
  edcst_ipi_id.BeforeLoadDFMValues;
  lbnome.BeforeLoadDFMValues;
  ednome.BeforeLoadDFMValues;
  lbexcluido.BeforeLoadDFMValues;
  edexcluido.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  lbexclusao.BeforeLoadDFMValues;
  edexclusao.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  Cst_IpiDataset.BeforeLoadDFMValues;
  Cst_IpiDatasetcst_ipi_id.BeforeLoadDFMValues;
  Cst_IpiDatasetnome.BeforeLoadDFMValues;
  Cst_IpiDatasetexcluido.BeforeLoadDFMValues;
  Cst_IpiDatasetinclusao.BeforeLoadDFMValues;
  Cst_IpiDatasetalteracao.BeforeLoadDFMValues;
  Cst_IpiDatasetexclusao.BeforeLoadDFMValues;
  XDataClientCst_IpiGet.BeforeLoadDFMValues;
  XDataClientCst_IpiDelete.BeforeLoadDFMValues;
  try
    Name := 'FViewCst_IpiEdit';
    Left := 0;
    Top := 0;
    Width := 593;
    Height := 427;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    TabOrder := 1;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    pnlMessage.SetParentComponent(Self);
    pnlMessage.Name := 'pnlMessage';
    pnlMessage.Left := 296;
    pnlMessage.Top := 113;
    pnlMessage.Width := 273;
    pnlMessage.Height := 60;
    pnlMessage.BorderColor := clSilver;
    pnlMessage.BorderStyle := bsSingle;
    lbMessage.SetParentComponent(pnlMessage);
    lbMessage.Name := 'lbMessage';
    lbMessage.Left := 16;
    lbMessage.Top := 24;
    lbMessage.Width := 42;
    lbMessage.Height := 13;
    lbMessage.Caption := 'Message';
    lbMessage.Transparent := True;
    btCloseMessage.SetParentComponent(pnlMessage);
    btCloseMessage.Name := 'btCloseMessage';
    btCloseMessage.Left := 248;
    btCloseMessage.Top := 11;
    btCloseMessage.Width := 22;
    btCloseMessage.Height := 25;
    btCloseMessage.Caption := 'x';
    btCloseMessage.TabOrder := 0;
    SetEvent(btCloseMessage, Self, 'OnClick', 'btCloseMessageClick');
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 126;
    btCancel.Top := 367;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Cancel';
    btCancel.TabOrder := 1;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    btSave.SetParentComponent(Self);
    btSave.Name := 'btSave';
    btSave.Left := 24;
    btSave.Top := 367;
    btSave.Width := 96;
    btSave.Height := 25;
    btSave.Caption := 'Save';
    btSave.TabOrder := 4;
    SetEvent(btSave, Self, 'OnClick', 'btSaveClick');
    btDelete.SetParentComponent(Self);
    btDelete.Name := 'btDelete';
    btDelete.Left := 305;
    btDelete.Top := 367;
    btDelete.Width := 96;
    btDelete.Height := 25;
    btDelete.Caption := 'Delete';
    btDelete.TabOrder := 5;
    SetEvent(btDelete, Self, 'OnClick', 'btDeleteClick');
    lbcst_ipi_id.SetParentComponent(Self);
    lbcst_ipi_id.Name := 'lbcst_ipi_id';
    lbcst_ipi_id.Left := 24;
    lbcst_ipi_id.Top := 192;
    lbcst_ipi_id.Width := 14;
    lbcst_ipi_id.Height := 13;
    lbcst_ipi_id.Caption := 'cst_ipi_id:';
    lbcst_ipi_id.Transparent := True;
    edcst_ipi_id.SetParentComponent(Self);
    edcst_ipi_id.Name := 'edcst_ipi_id';
    edcst_ipi_id.Left := 221;
    edcst_ipi_id.Top := 189;
    edcst_ipi_id.Width := 200;
    edcst_ipi_id.Height := 21;
    edcst_ipi_id.Enabled := True;
    edcst_ipi_id.TabOrder := 6;
    edcst_ipi_id.Text := 'edcst_ipi_id';
    edcst_ipi_id.DataField := 'cst_ipi_id';
    edcst_ipi_id.DataSource := DataSource;
    lbnome.SetParentComponent(Self);
    lbnome.Name := 'lbnome';
    lbnome.Left := 24;
    lbnome.Top := 219;
    lbnome.Width := 14;
    lbnome.Height := 13;
    lbnome.Caption := 'nome:';
    lbnome.Transparent := True;
    ednome.SetParentComponent(Self);
    ednome.Name := 'ednome';
    ednome.Left := 221;
    ednome.Top := 216;
    ednome.Width := 200;
    ednome.Height := 21;
    ednome.Enabled := True;
    ednome.TabOrder := 7;
    ednome.Text := 'ednome';
    ednome.DataField := 'nome';
    ednome.DataSource := DataSource;
    lbexcluido.SetParentComponent(Self);
    lbexcluido.Name := 'lbexcluido';
    lbexcluido.Left := 24;
    lbexcluido.Top := 246;
    lbexcluido.Width := 14;
    lbexcluido.Height := 13;
    lbexcluido.Caption := 'excluido:';
    lbexcluido.Transparent := True;
    edexcluido.SetParentComponent(Self);
    edexcluido.Name := 'edexcluido';
    edexcluido.Left := 221;
    edexcluido.Top := 243;
    edexcluido.Width := 200;
    edexcluido.Height := 21;
    edexcluido.Enabled := True;
    edexcluido.TabOrder := 8;
    edexcluido.Text := 'edexcluido';
    edexcluido.DataField := 'excluido';
    edexcluido.DataSource := DataSource;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 24;
    lbinclusao.Top := 273;
    lbinclusao.Width := 14;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'inclusao:';
    lbinclusao.Transparent := True;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 221;
    edinclusao.Top := 270;
    edinclusao.Width := 200;
    edinclusao.Height := 21;
    edinclusao.Enabled := True;
    edinclusao.TabOrder := 9;
    edinclusao.Text := 'edinclusao';
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 24;
    lbalteracao.Top := 300;
    lbalteracao.Width := 14;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'alteracao:';
    lbalteracao.Transparent := True;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 221;
    edalteracao.Top := 297;
    edalteracao.Width := 200;
    edalteracao.Height := 21;
    edalteracao.Enabled := True;
    edalteracao.TabOrder := 10;
    edalteracao.Text := 'edalteracao';
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    lbexclusao.SetParentComponent(Self);
    lbexclusao.Name := 'lbexclusao';
    lbexclusao.Left := 24;
    lbexclusao.Top := 327;
    lbexclusao.Width := 14;
    lbexclusao.Height := 13;
    lbexclusao.Caption := 'exclusao:';
    lbexclusao.Transparent := True;
    edexclusao.SetParentComponent(Self);
    edexclusao.Name := 'edexclusao';
    edexclusao.Left := 221;
    edexclusao.Top := 324;
    edexclusao.Width := 200;
    edexclusao.Height := 21;
    edexclusao.Enabled := True;
    edexclusao.TabOrder := 11;
    edexclusao.Text := 'edexclusao';
    edexclusao.DataField := 'exclusao';
    edexclusao.DataSource := DataSource;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := Cst_IpiDataset;
    DataSource.Left := 176;
    DataSource.Top := 56;
    Cst_IpiDataset.SetParentComponent(Self);
    Cst_IpiDataset.Name := 'Cst_IpiDataset';
    Cst_IpiDataset.AfterApplyUpdates := Cst_IpiDatasetAfterApplyUpdates;
    Cst_IpiDataset.EntitySetName := 'Cst_Ipi';
    Cst_IpiDataset.Connection := DMConnection.ApiConnection;
    Cst_IpiDataset.Left := 176;
    Cst_IpiDataset.Top := 8;
    Cst_IpiDatasetcst_ipi_id.SetParentComponent(Cst_IpiDataset);
    Cst_IpiDatasetcst_ipi_id.Name := 'Cst_IpiDatasetcst_ipi_id';
    Cst_IpiDatasetcst_ipi_id.FieldName := 'cst_ipi_id';
    Cst_IpiDatasetcst_ipi_id.Required := True;
    Cst_IpiDatasetcst_ipi_id.Size := 255;
    Cst_IpiDatasetnome.SetParentComponent(Cst_IpiDataset);
    Cst_IpiDatasetnome.Name := 'Cst_IpiDatasetnome';
    Cst_IpiDatasetnome.FieldName := 'nome';
    Cst_IpiDatasetnome.Required := True;
    Cst_IpiDatasetnome.Size := 255;
    Cst_IpiDatasetexcluido.SetParentComponent(Cst_IpiDataset);
    Cst_IpiDatasetexcluido.Name := 'Cst_IpiDatasetexcluido';
    Cst_IpiDatasetexcluido.FieldName := 'excluido';
    Cst_IpiDatasetexcluido.Required := False;
    Cst_IpiDatasetinclusao.SetParentComponent(Cst_IpiDataset);
    Cst_IpiDatasetinclusao.Name := 'Cst_IpiDatasetinclusao';
    Cst_IpiDatasetinclusao.FieldName := 'inclusao';
    Cst_IpiDatasetinclusao.Required := False;
    Cst_IpiDatasetalteracao.SetParentComponent(Cst_IpiDataset);
    Cst_IpiDatasetalteracao.Name := 'Cst_IpiDatasetalteracao';
    Cst_IpiDatasetalteracao.FieldName := 'alteracao';
    Cst_IpiDatasetalteracao.Required := False;
    Cst_IpiDatasetexclusao.SetParentComponent(Cst_IpiDataset);
    Cst_IpiDatasetexclusao.Name := 'Cst_IpiDatasetexclusao';
    Cst_IpiDatasetexclusao.FieldName := 'exclusao';
    Cst_IpiDatasetexclusao.Required := False;
    XDataClientCst_IpiGet.SetParentComponent(Self);
    XDataClientCst_IpiGet.Name := 'XDataClientCst_IpiGet';
    XDataClientCst_IpiGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientCst_IpiGet, Self, 'OnLoad', 'XDataClientCst_IpiGetLoad');
    XDataClientCst_IpiGet.Left := 64;
    XDataClientCst_IpiGet.Top := 8;
    XDataClientCst_IpiDelete.SetParentComponent(Self);
    XDataClientCst_IpiDelete.Name := 'XDataClientCst_IpiDelete';
    XDataClientCst_IpiDelete.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientCst_IpiDelete, Self, 'OnLoad', 'XDataClientCst_IpiDeleteLoad');
    SetEvent(XDataClientCst_IpiDelete, Self, 'OnError', 'XDataClientCst_IpiDeleteError');
    XDataClientCst_IpiDelete.Left := 64;
    XDataClientCst_IpiDelete.Top := 56;
  finally
    pnlMessage.AfterLoadDFMValues;
    lbMessage.AfterLoadDFMValues;
    btCloseMessage.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    btSave.AfterLoadDFMValues;
    btDelete.AfterLoadDFMValues;
    lbcst_ipi_id.AfterLoadDFMValues;
    edcst_ipi_id.AfterLoadDFMValues;
    lbnome.AfterLoadDFMValues;
    ednome.AfterLoadDFMValues;
    lbexcluido.AfterLoadDFMValues;
    edexcluido.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    lbexclusao.AfterLoadDFMValues;
    edexclusao.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    Cst_IpiDataset.AfterLoadDFMValues;
    Cst_IpiDatasetcst_ipi_id.AfterLoadDFMValues;
    Cst_IpiDatasetnome.AfterLoadDFMValues;
    Cst_IpiDatasetexcluido.AfterLoadDFMValues;
    Cst_IpiDatasetinclusao.AfterLoadDFMValues;
    Cst_IpiDatasetalteracao.AfterLoadDFMValues;
    Cst_IpiDatasetexclusao.AfterLoadDFMValues;
    XDataClientCst_IpiGet.AfterLoadDFMValues;
    XDataClientCst_IpiDelete.AfterLoadDFMValues;
  end;
end;

end.
